<template>
    <div class="lineBox">
        <template></template>
        <div class="header" >
            <div class="bn left">
                <div class="top">
                    <span></span>
                    <span>{{playerList.home_team_info.team_name}}</span>
                    <span>{{playerList.home_formation}}</span>
                </div>
                <div class="down">
                    <span>主教练：</span>
                    <span>{{playerList.home_team_info.coach_name}}</span>
                </div>
            </div>
            <div class="bn right">
                <div class="down">
                    <span>主教练：</span>
                    <span>{{playerList.away_team_info.coach_name}}</span>
                </div>
                <div class="top">
                    <span>{{playerList.away_formation}}</span>
                    <span>{{playerList.away_team_info.team_name}}</span>
                    <span></span>
                </div>
            </div>
        </div>
        <div class="body">
            <div class="box left">
                <div class="home goalkeeper">
                    <itemline
                    :item="dealPosition(playerList.home_starter_list,1)"
                    :stut="playerList.has_lineup"
                    />
                </div>
                <div class="home" v-for="item,index in home_player_arr" :key="index">
                    <itemline
                    v-for="is,k in item" :key="k"
                    :item="is"
                    :stut="playerList.has_lineup"
                    />
                    
                </div>
            </div>
            <div class="box right">
                <div class="home" v-for="item,index in away_player_arr" :key="index">
                    <itemline
                    v-for="is,k in item" :key="k"
                    :item="is"
                    :stut="playerList.has_lineup"
                    type="away"
                    />
                    
                </div>
                <div class="home goalkeeper">
                    <itemline
                    :item="dealPosition(playerList.away_starter_list,1)"
                    :type="type"
                    :stut="playerList.has_lineup"
                    />
                </div>
            </div>
        </div>
        <div class="yu" v-if="playerList.has_lineup == 2"></div>
    </div>
    
</template>

<script>
import itemline from "./itemline.vue"
export default {
    name: "lineBox",
    props: ["playerList"],
    components: {
        itemline
    },
    data () {
        return {
           alertModel: false,
           alertItem: {},
           type: false
        }
    },
    computed:{
        home_player_arr () {
            return this.teamPlayer(1)
        },
        away_player_arr () {
            return this.teamPlayer(2)
        }
    },
    methods: {
        changeTeam (item,type) {
            // if (this.alertModel) return
            if (type == 'away') {
                this.type = true
            } else{
                this.type = false
            }
            this.alertModel = true
            this.alertItem = item
        },
        closeModel () {
            this.alertModel = false
            this.type = false
        },
        teamPlayer (type) {
            const list = [];
            let arr = []; // 阵型分布
            let lineUp = []; // 球员集合
            if (type === 1) {
                arr = this.playerList.home_formation ? this.playerList.home_formation.split('-') : [1,3,4,2]
                lineUp = this.playerList.home_starter_list;
            } else {
                arr = this.playerList.away_formation ? this.playerList.away_formation.split('-') : [1,3,4,2]
                lineUp = this.playerList.away_starter_list;
            }
            let index = 1;
            for (let i = 0; i < arr.length; i++) {
                const itemArr = [];
                for (let j = 0; j < parseInt(arr[i]); j++) {
                    index++;
                    // 客队是镜像数据
                    const item = this.dealPosition(lineUp, index);
                    if (type === 1) {
                        itemArr.push(item)
                    } else {
                        itemArr.unshift(item)
                    }
                }
                list.push(itemArr)
            }
            if (type === 1) {
                return list
            } else {
                return list.reverse()
            }
        },
        // 处理位置信息
        dealPosition (arr, index) {
            const obj = {};
            for (let i = 0; i < arr.length; i++) {
                if (parseInt(arr[i].position) === index) {
                    obj.base = arr[i];
                    const status = {};
                    if (arr[i].event_list) {
                        const eventList = arr[i].event_list;
                        for (let j = 0; j < eventList.length; j++) {
                            if (eventList[j].type_id === '18') {
                                status.showYellowPaper = true
                            } else if (eventList[j].type_id === '21') {
                                status.showTwoPaper = true
                            } else if (eventList[j].type_id === '22') {
                                status.showRedPaper = true
                            } else if (eventList[j].type_id === '9') {
                                if (arr[i].player_id == eventList[j].player_id) {
                                    // 进球 goal_type
                                    if (eventList[j].goal_type === '2') {
                                        // 乌龙球
                                        status.showRedBall = true
                                    } else if (eventList[j].goal_type === '4') {
                                        // 点球
                                        status.showYellowBall = true
                                    } else {
                                        status.showBlackBall = true
                                    }
                                }
                            }
                            if (eventList[j].type_id === '23') {
                                status.showExchange = true;
                            }
                        }
                    }
                    obj.status = status;
                    return obj
                }
            }
        }
    }

}
</script>

<style lang="less">
.lineBox{
    text-align: center;
    margin-top: 20px;
    margin-bottom: 10px;
    height: 540px;
    width: 919px;
    background: #FFFFFF;
    box-shadow: 0px 0px 20px 0px rgba(21, 21, 21, 0.06);
    position: relative;
    .header{
        width: 919px;
        height: 40px;
        background: #5BA25A;
        display: flex;
        justify-content: space-between;
        .bn{
            font-size: 15px;
            font-weight: 400;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            .down{
                margin: 0 30px;
                font-size: 13px;
            }
            div{
                display: flex;
                align-items: center;
            }
        }
        .left{
            .top{
                span{
                    &:first-child{
                        display: inline-block;
                        width: 6px;
                        height: 16px;
                        background: url("../../../assets/img/matchDetails/inbox_left.png");
                        background-size:100% 100% ;
                        margin-right: 20px;
                    }
                    &:last-child{
                        margin-left:10px ;
                    }
                }
            }
        }
        .right{
            .top{
                span{
                    &:first-child{
                        margin-right:10px ;
                    }
                    &:last-child{
                        display: inline-block;
                        width: 6px;
                        height: 16px;
                        background: url("../../../assets/img/matchDetails/lineup_team_away.png");
                        background-size:100% 100% ;
                        margin-left: 20px;
                    }
                }
            }
        }
    }
    .yu{
        background: url("../../../assets/img/matchDetails/linBox_yu.png");
        background-size: 100% 100%;
        z-index: 100;
        width: 46px;
        height: 35px;
       position: relative;
        margin: auto;
        top: -268px;
    }
    .body{
        background: url("../../../assets/img/matchDetails/lineup_bg.png");
        background-size: 100% 100%;
        height: 500px;
        display: flex;
        .box{
            flex: 1;
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .home{
                cursor: pointer;
                display: flex;
                flex-direction:column;
                justify-content: space-around;
                height: 100%;
                div{
                    height: 100px;
                    width: 90px;
                    span{
                        display: flex;
                        justify-content: center;
                    }
                    .yf{
                        width: 35px;
                        height: 38px;
                        background: url("../../../assets/img/matchDetails/lineup_team_home.png");
                        background-size:100% 100% ;
                        line-height: 38px;
                        margin: 0 auto;
                        // &::after{
                        //     content: "";
                        //     display: inline-block;
                        //     width: 40px;
                        //     height: 40px;
                        //     background: red;
                        //     margin-right:-80px;
                        //     position: absolute;
                        // }
                        z-index: 100;
                        position: absolute;
                        margin-left:30px ;
                        // box-shadow: 0px 10px 0px rgba(0, 0, 0, 0.5);
                    }
                    .yy{
                        width: 54px;
                        height: 22px;
                        background: url("../../../assets/img/matchDetails/linBox_yy.png");
                        background-size:100% 100% ;
                        // position: absolute;
                        margin-top: 28px;
                        margin-left:20px ;
                    }
                    .name{
                        margin-top:-3px ;
                    }
                    .score{
                        width: 40px;
                        height: 18px;
                        border-radius: 9px;
                        margin: 0 auto;
                        margin-top:8px ;
                        // line-height: 18px;
                        i{
                            line-height: 18px;
                            margin-right:-4px ;
                        }
                    }
                    .img{
                        height: 40px;
                        width: 40px;
                        float: right;
                        // background: royalblue;
                        margin-top:-95px ;
                        margin-right:-18px ;
                        display: flex;
                        justify-content: flex-start;
                        flex-wrap: wrap;
                        img{
                            width: 20px;
                            height: 20px;

                        }
                    }
                }
            }
        }
        .right{
            .home{
                div{
                    .yf{
                        background: url("../../../assets/img/matchDetails/lineup_team_away.png");
                        background-size:100% 100% ;
                    }
                }
            }
        }
    }
}
</style>